import React from 'react';

const PAGE_META = {
  home:        { icon: '🏠', label: 'Inicio' },
  services:    { icon: '🕐', label: 'Servicios' },
  giving:      { icon: '🤲', label: 'Dar' },
  'give-form': { icon: '🤲', label: 'Dar' },
  media:          { icon: '📺', label: 'En Vivo' },
  events:         { icon: '📅', label: 'Eventos' },
  'prayer-modal': { icon: '🙏', label: 'Oración' },
  profile:     { icon: '👤', label: 'Perfil' },
};

export default function Nav({ pages, active, onNavigate }) {
  return (
    <nav className="nav">
      {pages.map(p => {
        const meta = PAGE_META[p.id] || {};
        return (
          <button
            key={p.id}
            className={`nav-btn${active === p.id ? ' active' : ''}`}
            onClick={() => onNavigate(p.id)}
          >
            <span className="nav-icon">{meta.icon}</span>
            <span>{meta.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
